import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import moment from "moment";
// material
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  Grid,
  TextField
} from "@mui/material";

import { Routes } from "src/constant/api_url";

import Page from "../components/Page";
import { MeetingForm } from "../components/Form/Meeting";
import { EditSharp, RestartAlt, DeleteSharp, PeopleAlt } from "@mui/icons-material";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import {
  deleteMeeting,
  GetMeetingById,
  getMeetingByUserV2,
  gettPendingmemberVisitorApi,
  resetMeetingMember
} from "src/api/commonapi";
import Select from "react-select";
import {
  fetchallcitylist,
  fetchchapterbyuser
} from "src/utils/common";
import { notification } from "src/utils/messages";
import Deletemodal from "./DeleteModal";
import { CSVLink } from "react-csv";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import CustomLoader from "src/commonComponents/CustomLoader";

const DEBOUNCE_DELAY = 500;

// Backend persists submit_member_role on meeting close (§2). Recompose the
// closer label here — do not parse the old " - Director" name suffix.
const formatMeetingCloser = (row) => {
  const base = String(row?.meeting_end_by_per ?? "").trim();
  const suffix =
    row?.submit_member_role == 1
      ? "Director"
      : row?.submit_member_role == 2
        ? "Support Director"
        : "";
  if (!suffix) return base || "-";
  if (!base) return suffix;
  // Legacy rows may already carry the suffix — never double-append.
  if (base.includes(" - Director") || base.includes(" - Support Director")) return base;
  return `${base} - ${suffix}`;
};

export default function Meeting() {
  const location = useLocation();
  const navigate = useNavigate();
  const [initialState, setInitialState] = useState(() => location.state);
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [step, setStep] = useState(1);
  const [meetinglist, setMeetingList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [PendingMeetingVisitorList, setPendingMeetingVisitorList] = useState([]);
  const [meetingData, setmeetingData] = useState(null);
  const [chaptlist, setchaplist] = useState([]);
  const [filterOption, setFilterOption] = useState([{ value: 0, label: "All Chapters" }]);
  const [tab, setTab] = useState(initialState?.tab || "pending");
  const [pendingCount, setPendingCount] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [filter, setFilter] = useState(
    () =>
      initialState?.filter || {
        chpt_id: 0,
        city_id:
          loginUser?.u_type == 1 ||
            (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
            ? loginUser?.city_id
            : location.state?.city || 0,
        startDate: null,
        endDate: null
      }
  );

  const [currentPage, setCurrentPage] = useState(initialState?.currentPage || 1);

  const [citylist, setcitylist] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [isExporting, setIsExporting] = useState(false);

  const debounceTimerRef = useRef(null);
  const fetchMeetingRef = useRef(null);
  const csvLinkRef = useRef(null);

  const debouncedFetch = useCallback((page, perPage) => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    debounceTimerRef.current = setTimeout(() => {
      if (fetchMeetingRef.current) {
        fetchMeetingRef.current(page, perPage);
      }
    }, DEBOUNCE_DELAY);
  }, []);

  const fetchMeeting = async (page = 1, perPage = rowsPerPage) => {
    setIsLoading(true);
    const payload = {
      city_id: filter.city_id,
      chpt_id: filter.chpt_id,
      start_date: filter.startDate ? moment(filter.startDate).format("YYYY-MM-DD") : null,
      end_date: filter.endDate ? moment(filter.endDate).format("YYYY-MM-DD") : null,
      status: tab === "pending" ? 0 : -1,
      page,
      per_page: perPage,
      u_type: loginUser.u_type,
      login_user_city_id: loginUser.city_id
    };
    const res = await getMeetingByUserV2(payload);
    if (res?.status === 1) {
      setMeetingList(res?.data?.meetings || []);
      setTotalRows(res?.data?.total || 0);
      setPendingCount(res?.data?.pending_count || 0);
      setCompletedCount(res?.data?.completed_count || 0);
    }
    setIsLoading(false);
  };

  fetchMeetingRef.current = fetchMeeting;

  useEffect(() => {
    fetchchapterbyuser(loginUser.city_id, loginUser.u_type).then((data) => setchaplist(data));
    fetchMeeting(1, rowsPerPage);
  }, []);

  useEffect(() => {
    chaptlist.map((option) => {
      filterOption.push({ value: option.chpt_id, label: option.chpt_name });
    });
  }, [chaptlist]);

  const resetmeeting = async (m_id) => {
    const resp = await resetMeetingMember(m_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      fetchMeeting(currentPage, rowsPerPage);
    }
  };

  // Delete Meeting
  const deletemeeting = async (m_id) => {
    const resp = await deleteMeeting(m_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      fetchMeeting(currentPage, rowsPerPage);
      setDvisible({ mval: false, id: 0 });
    }
  };

  const getAttendance = async (e, row) => {
    navigate(`/attendace/${e}`, {
      state: {
        id: e,
        name: formatMeetingCloser(row),
        date: row.date,
        filter,
        tab,
        currentPage,
        status: row.status,
        PendingMeetingVisitorList,
        chapter: row.chpt_name
      }
    });
  };

  const handleGetVisitorOfMeeting = async (member_id, row) => {
    const response = await gettPendingmemberVisitorApi(member_id);
    setPendingMeetingVisitorList(response?.data || []);

    navigate(`/attendace/${member_id}`, {
      state: {
        id: member_id,
        name: formatMeetingCloser(row),
        date: row.date,
        filter,
        tab,
        currentPage,
        status: row.status,
        PendingMeetingVisitorList: response?.data || [],
        chapter: row.chpt_name
      }
    });
  };
  const getMeeting = async (e) => {
    const response = await GetMeetingById(e);
    if (Object.keys(response).length != 0) {
      setmeetingData(response);
      setStep(3);
    }
  };
  useEffect(() => {
    setCurrentPage(1);
    debouncedFetch(1, rowsPerPage);
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [filter, tab]);

  useEffect(() => {
    fetchallcitylist().then((data) => setcitylist(data));
  }, []);

  const previewFunction = async (url, path) => {
    if (!url) return;

    const fileName = url;

    const response = await fetch(`${Routes.API_HOSTNAME}${path}/${encodeURIComponent(fileName)}`);

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    window.open(blobUrl, "_blank"); // 👈 open preview
  };
  const expo_columns = [
    { label: "No", key: "meeting_id" },
    { label: "Chapter Name", key: "chpt_name" },
    { label: "Date", key: "date" },
    { label: "Presentative", key: "bus_pre_name" },
    { label: "Second Presentative", key: "bus_s_pre_name" },
    { label: "Meeting End By", key: "meeting_end_by_per" },
    { label: "Address", key: "address" },
    { label: "Learning Session", key: "learning_session_name" },
    { label: "Guest Speaker", key: "guest_speaker" }
  ];
  const columns = [
    {
      name: "No",
      selector: (row) => row.meeting_id,
      wrap: true,
      sortable: true,
      width: "100px"
    },
    {
      name: "Chapter Name",
      selector: (row) => row.chpt_name,
      sortable: true,
      wrap: true,
      width: "150px"
    },
    {
      name: "Date",
      // selector: (row) => row.date,
      wrap: true,
      width: "150px",
      cell: (row) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const [day, month, year] = row.date.split("-");
        const rowDate = new Date(year, month - 1, day);
        rowDate.setHours(0, 0, 0, 0);

        let bgColor = ""; // default
        let textColor = "";

        if (rowDate.getTime() === today.getTime()) {
          bgColor = "#d4edda"; // light green
          textColor = "#155724";
        } else if (rowDate.getTime() < today.getTime()) {
          bgColor = "#f8d7da"; // light red
          textColor = "#721c24";
        }

        return (
          <div
            style={{
              backgroundColor: tab === "pending" ? bgColor : "",
              color: tab === "pending" ? textColor : "",
              padding: "4px 4px",
              borderRadius: "6px",
              fontWeight: 500,
              textAlign: "center",
              fontWeight: "bold"
            }}
          >
            {row.date}
          </div>
        );
      }
    },
    {
      name: "1st Presenter",
      selector: (row) => row.bus_pre_name,
      wrap: true,
      sortable: true,
      width: "155px"
    },
    {
      name: "2nd Presenter",
      wrap: true,
      selector: (row) => row.bus_s_pre_name,
      sortable: true,
      width: "155px"
    },
    {
      name: "Learning Session",
      selector: (row) => row.learning_session_name,
      wrap: true,
      sortable: true,
      width: "155px"
    },
    {
      name: "Guest Speaker",
      wrap: true,
      selector: (row) => row.guest_speaker,
      sortable: true,
      width: "155px"
    },
    {
      name: "Change Of Guard",
      wrap: true,
      selector: (row) => row.change_of_guard == 1 ? 'Yes' : 'No',
      sortable: true,
      width: "155px"
    },
    {
      name: " Address",
      wrap: true,
      selector: (row) => row.address,
      sortable: true,
      width: "155px"
    },
    {
      name: "Meeting Close By",
      wrap: true,
      selector: (row) => formatMeetingCloser(row)
      // sortable: true,
    },
    {
      name: "Meeting Closed At",
      wrap: true,
      selector: (row) => row?.meeting_end_date,
      width: "200px"
      // sortable: true,
    },
    {
      name: "Meeting Details Added By",
      wrap: true,
      selector: (row) => row?.meeting_updated_by_name,
      width: "200px"
      // sortable: true,
    },
    {
      name: "Meeting Details Added At",
      wrap: true,
      selector: (row) => row?.meeting_updated_date,
      width: "200px"
      // sortable: true,
    },
    {
      name: "Action",
      wrap: true,
      selector: (row) => row.meet_note,
      sortable: true,
      width: "200px",
      selector: (row) => (
        <>
          {row.status != "-1" ? (
            <>
              <Tooltip title="Edit Meeting Date">
                <IconButton
                  onClick={() => {
                    getMeeting(row.meeting_id);
                  }}
                >
                  <EditSharp color="warning" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Remove Presentative">
                <IconButton
                  onClick={() => {
                    resetmeeting(row.meeting_id);
                  }}
                >
                  <RestartAlt color="error" />
                </IconButton>
              </Tooltip>
              {(loginUser.u_type == 0 || (loginUser.u_type == 2 && loginUser.p_user_id == 1)) && (
                <Tooltip title="Delete Meeting">
                  <IconButton
                    onClick={() => {
                      setDvisible({ mval: true, id: row.meeting_id });
                      // deletemeeting(row.meeting_id);
                    }}
                  >
                    <DeleteSharp color="error" />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title="Visitors Of Meeting">
                <IconButton
                  onClick={() => {
                    handleGetVisitorOfMeeting(row.meeting_id, row);
                  }}
                >
                  <PeopleAlt color="info" />
                </IconButton>
              </Tooltip>
            </>
          ) : (
            <>
              <Tooltip title="Attendance Of Meeting">
                <IconButton
                  onClick={() => {
                    getAttendance(row.meeting_id, row);
                  }}
                >
                  <PeopleAlt color="info" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Meeting End Report">
                <IconButton
                  onClick={() => {
                    previewFunction(row.meeting_end_report, "meeting-end-report");
                  }}
                >
                  <FactCheckIcon color="warning" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Meeting Attendance Report">
                <IconButton
                  onClick={() => {
                    previewFunction(row.attendance_report, "attendance-report");
                  }}
                >
                  <FactCheckIcon color="primary" />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      )
    }
  ];

  const ClearSearchResult = async () => {
    setFilter({
      chpt_id: 0,
      city_id:
        loginUser?.u_type == 1 ||
          (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
          ? loginUser?.city_id
          : 0,
      startDate: null,
      endDate: null
    });
  };

  const handleExportCSV = async () => {
    setIsExporting(true);
    const payload = {
      city_id: filter.city_id,
      chpt_id: filter.chpt_id,
      start_date: filter.startDate ? moment(filter.startDate).format("YYYY-MM-DD") : null,
      end_date: filter.endDate ? moment(filter.endDate).format("YYYY-MM-DD") : null,
      status: tab === "pending" ? 0 : -1,
      page: 1,
      per_page: totalRows || 99999,
      u_type: loginUser.u_type,
      login_user_city_id: loginUser.city_id
    };
    const res = await getMeetingByUserV2(payload);
    if (res?.status === 1) {
      setExportData(
        (res?.data?.meetings || []).map((m) => ({
          ...m,
          meeting_end_by_per: formatMeetingCloser(m)
        }))
      );
    }
    setIsExporting(false);
  };

  useEffect(() => {
    if (exportData.length > 0 && csvLinkRef.current) {
      csvLinkRef.current.click();
      setExportData([]);
    }
  }, [exportData]);

  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, { replace: true });
    }
  }, []);

  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={deletemeeting} />
      <Page title="Meeting | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Meeting
            </Typography>
          </Stack>

          {step != 1 && (
            <>
              <Card
                style={{
                  paddingTop: "25px",
                  paddingBottom: "25px",
                  marginBottom: "25px"
                }}
              >
                <MeetingForm
                  fetchMeeting={fetchMeeting}
                  data={meetingData}
                  setStep={setStep}
                  step={step}
                />
              </Card>
            </>
          )}

          <Card
            style={{
              padding: "25px",
              marginBottom: "25px",
              marginTop: "25px"
            }}
          >
            <Grid container spacing={2} sx={{ alignItems: "center" }}>
              <Grid item xs={2}>
                <Stack sx={{ marginBottom: "15px" }}>
                  <label>Select City</label>
                  <Select
                    menuPortalTarget={document.body}
                    isDisabled={
                      loginUser?.u_type == 1 ||
                        (loginUser?.u_type == 2 &&
                          loginUser?.p_user_id != 1 &&
                          loginUser?.management_p == 1)
                        ? true
                        : false
                    }
                    options={[
                      {
                        value: 0,
                        label: "All City"
                      },
                      ...citylist.map((city) => {
                        return {
                          label: city?.city_name,
                          value: city?.city_id
                        };
                      })
                    ]}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        city_id: e.value,
                        chpt_id: 0
                      });
                    }}
                    value={
                      filter.city_id == 0
                        ? {
                          value: 0,
                          label: "All City"
                        }
                        : citylist.map((city) => {
                          return (
                            filter.city_id == city.city_id && {
                              value: city.city_id,
                              label: city.city_name
                            }
                          );
                        })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <label>Select Chapter</label>
                  <Select
                    name="chpt_id"
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        chpt_id: e.value
                      });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All Chapter"
                      },
                      ...(chaptlist &&
                        chaptlist
                          ?.map((chpt) => {
                            if (filter?.city_id != 0) {
                              if (chpt?.city_id == filter?.city_id) {
                                return {
                                  value: chpt.chpt_id,
                                  label: chpt.chpt_name
                                };
                              }
                            } else {
                              return {
                                value: chpt.chpt_id,
                                label: chpt.chpt_name
                              };
                            }
                          })
                          .filter((f) => f != undefined))
                    ]}
                    value={
                      filter.chpt_id == 0
                        ? { value: 0, label: "All Chapter" }
                        : chaptlist &&
                        chaptlist.map((c) => {
                          if (c.chpt_id == filter.chpt_id) {
                            return {
                              value: c.chpt_id,
                              label: c.chpt_name
                            };
                          }
                        })
                    }
                  />
                  {/* <ChapterSelectDropDown
                    dropDownLabel={"Select Chapter"}
                    selectedState={filter}
                    chapterKey="chpt_id"
                    handleChange={(e) => {
                      setFilter({ chpt_id: e.value });
                    }}
                  /> */}
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={0}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "0px" }}>
                    <label>Select Meeting Start Date</label>
                    <DatePicker
                      type="date"
                      name="s_date"
                      label="Start Date "
                      inputFormat="dd/MM/yyyy"
                      value={filter.startDate != null ? filter.startDate : null}
                      onChange={(newDate) => {
                        setFilter({
                          ...filter,
                          startDate: newDate
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                        // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={0}>
                  <label>Select Meeting End Date</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      type="date"
                      name="e_date"
                      label="End Date "
                      inputFormat="dd/MM/yyyy"
                      value={filter.endDate != null ? filter.endDate : null}
                      onChange={(newDate) => {
                        setFilter({
                          ...filter,
                          endDate: newDate
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                        // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={1} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "space-between"
                  }}
                >
                  <Button variant="outlined" onClick={ClearSearchResult}>
                    Clear
                  </Button>
                </div>
              </Grid>
            </Grid>

            {meetinglist && (
              <>
                <Button
                  className="btn btn-export"
                  onClick={handleExportCSV}
                  disabled={isExporting}
                >
                  {isExporting ? "Exporting..." : "Export CSV"}
                </Button>
                {exportData.length > 0 && (
                  <CSVLink
                    ref={csvLinkRef}
                    data={exportData}
                    headers={expo_columns}
                    filename={"MeetingList.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Download CSV
                  </CSVLink>
                )}

                <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                  <Button
                    variant={tab === "pending" ? "contained" : "outlined"}
                    onClick={() => setTab("pending")}
                  >
                    Pending Meeting ({pendingCount})
                  </Button>
                  <Button
                    variant={tab === "completed" ? "contained" : "outlined"}
                    onClick={() => setTab("completed")}
                  >
                    Completed Meeting ({completedCount})
                  </Button>
                </Stack>
              </>
            )}
            <DataTable
              title="Meeting List"
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              paginationPerPage={rowsPerPage}
              onChangePage={(page) => {
                setCurrentPage(page);
                fetchMeeting(page, rowsPerPage);
              }}
              onChangeRowsPerPage={(newPerPage, page) => {
                setRowsPerPage(newPerPage);
                fetchMeeting(page, newPerPage);
              }}
              highlightOnHover
              columns={columns}
              data={meetinglist}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          </Card>
          {/* End Category Form */}
        </Container>
      </Page>
    </>
  );
}
